import { ParsedUrlQuery } from 'querystring';
import { isDefined } from 'utils/type-guards';

export function getUtmCampaignForBlogPostFromQueryParam(query: ParsedUrlQuery): string {
  const { blogPostName, category1, category2, category3 } = query as {
    blogPostName: string;
    category1: string;
    category2: string;
    category3?: string;
  };

  const utmCampaign = `cli_${[category1, category2, category3, blogPostName]
    .filter(isDefined)
    .join('_')}`;
  return utmCampaign;
}

export interface Utm {
  utm_campaign: string;
  utm_medium: string;
  utm_source: string;
}

/**
 * Create Utm objects specifically for internal blog.
 * The utm object will only be returned when there is no existing utm values in the url.
 */
export function getUtmDataByQueryParamForInternalBlog(query: ParsedUrlQuery): Utm | null {
  const { utm_campaign, utm_medium, utm_source } = query as {
    utm_campaign?: string;
    utm_medium?: string;
    utm_source?: string;
  };

  if (!utm_source && !utm_medium && !utm_campaign) {
    const utmCampaign = getUtmCampaignForBlogPostFromQueryParam(query);
    const utmObjects: Utm = {
      utm_campaign: utmCampaign,
      utm_source: 'zehitomo',
      utm_medium: 'blog',
    };

    return utmObjects;
  }
  return null;
}

/**
 * The type of CTA that can be used.
 */
export const CTATypes = {
  fixed: 'fixed',
  following: 'following',
};

export function modifyUtmParamsWithCTAType(originalUtm: Utm, type: string): Utm {
  const modifiedUtmParams: Utm = {
    utm_campaign: `${originalUtm.utm_campaign}_${type}`,
    utm_medium: originalUtm.utm_medium,
    utm_source: originalUtm.utm_source,
  };
  return modifiedUtmParams;
}
